<template>
    <div class="EstimateList mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="list" v-for="item in EstimateListData">
            <span class="ListNo">No.{{item.estimateId}}</span>
            <br>
            <!-- 報價日期 -->
            <div class="d-flex">
                <span class="subtitle flex-shrink-0">報價日期：</span>
                <span class="data">{{showDate(item.estimateDate)}}</span>
            </div>
            <!-- 學校 -->
            <div class="d-flex">
                <span class="subtitle flex-shrink-0">學　　校：</span>
                <span class="data">{{item.school}}</span>
            </div>
            <!-- 課程 -->
            <div class="d-flex">
                <span class="subtitle flex-shrink-0 ">課　　程：</span>
                <div class="d-flex flex-column " > 
                    <span class="data flex-wrap" v-for="couseItem in item.couse">{{couseItem}}</span>
                </div>
            </div>
            <!-- 房型 -->
            <div class="d-flex">
                <span class="subtitle flex-shrink-0">房　　型：</span>
                <div class="d-flex flex-column " > 
                    <span class="data"  v-for="roomItem in item.room">{{roomItem}}</span>
                </div>
            </div>
            <!-- 學費 -->
            <div class="d-flex">
                <span class="subtitle flex-shrink-0">學　　費：</span>
                <span class="data">{{item.schoolFees}}</span>
            </div>
            <font-awesome-icon class="icon mx-2 " style="float:right" :icon="['fas','eye']" size="2x" @click="GoDetail(item.estimateId)"/>
            <br>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'EstimateList',
    components:{
        Nav,
    },
    data () {
        return {
            showLoading:'',
            DeweyUserId:'',
            EstimateListData:[],
            // EstimateListData:[{
            //     estimateId:69978,
            //     estimateDate:"2023-02-03 19:34:43", //報價日
            //     school:"CBOA", //學校
            //     couse:"Sparta Ameica - Single - 4week", //課程(可能會有多筆)
            //     room:"Twin Room", //房型
            //     schoolFees:"USD$ 3,730" //學費
            // },
            // {
            //     estimateId:69979,
            //     estimateDate:"2023-02-03 19:35:00", //報價日
            //     school:"CBOA", //學校
            //     couse:"Sparta Ameica - Single - 4week", //課程(可能會有多筆)
            //     room:"Twin Room", //房型
            //     schoolFees:"USD$ 3,000" //學費
            // }]
        }
    },
    methods:{
        GoDetail(estimateId){
            this.$router.push({
                name: 'EstimateDetail',
                params: {
                    estimateId:estimateId
                },
            });

        },
        GetEstimateList(){
            this.showLoading = true;

            const api =`${process.env.APIPATH}/api/Estimate/GetEstimateList`;
            const inputdata = 
            {
                "deweyUserId":this.DeweyUserId,
            };

            axios.post(api, inputdata)
                .then((response) => {                    
                    this.showLoading = false;

                    if(response.data.isSuccess){ 
                        this.EstimateListData = response.data.estimateListData
                    }else{
                        console.error("There was an error!", response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        showDate(date){
            return moment(date).format('yyyy-MM-DD HH:mm');
        },
    },
    created(){
        this.DeweyUserId=JSON.parse(sessionStorage.getItem('UserData')).deweyUserId;
        this.GetEstimateList();
    },
}
</script>






// WEBPACK FOOTER //
// src/components/line/EstimateList.vue